module.exports = __webpack_public_path__ + "static/media/timeline-back-black.b4a524bb.svg";